import {uniq} from 'lodash';
import React from 'react';
import CategoryInvalidFields from './CategoryInvalidFields/CategoryInvalidFields';
import styles from './InvalidFields.module.scss';

function InvalidFields(props) {
    const {invalidFields} = props,
        categories = uniq(invalidFields.map(invf => invf.category));

    if (!invalidFields.length) return null;

    return (
        <>
            <h6>The following columns are no longer available:</h6>
            <table className={['table table-condensed', styles.InvalidFieldsTable].join(' ')}>
                <thead>
                    <tr>
                        <th>Condition</th>
                        <th>Column</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {categories.map(categoryId => (
                        <CategoryInvalidFields
                            key={categoryId}
                            categoryId={categoryId}
                            invalidFields={invalidFields.filter(invf => invf.category == categoryId)}
                        />
                    ))}
                </tbody>
            </table>
        </>
    );
}

export default InvalidFields;
